export enum ETipoDesviacion {
  Observacion = 1,
  NoConformidad = 2,
  Conformidad = 3,
  OportunidadMejora = 4,
}
